import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {

  },

  mutations: {

  },

  actions: {

    // 会员信息
    async vipInfo ({ commit }, params) {
      const response = await axios.post('/membership/v1/info', params)
      return response.data
    },

    // 提额
    async vipLimitadjust ({ commit }, params) {
      const response = await axios.post('/membership/v1/apply-limitadjust', params)
      return response.data
    },

    // 用户已购会员广播
    async vipAdPrize ({ commit }, params) {
      const response = await axios.post('/membership/v1/list-prize', params)
      return response.data
    },

    // 放弃购买
    async orderCancel ({ commit }, params) {
      const response = await axios.post('/membership/v1/order-cancel', params)
      return response.data
    },

    // 获取token
    async getToken ({ commit }, params) {
      const response = await axios.post('/membership/v1/oak-token', params)
      return response.data
    },

    // 会员弹窗相关信息
    async popInfo ({ commit }, params) {
      const response = await axios.post('/membership/v1/pop-info', params)
      return response.data
    },

    // 未购买页面
    async groupInfo ({ commit }, params) {
      const response = await axios.post('/membership/v1/groupInfo', params)
      return response.data
    },

    // 未购买页面
    async memberInfo ({ commit }, params) {
      const response = await axios.post('/membership/v1/memberInfo', params)
      return response.data
    },

    // 未购买页面
    async goodsInfo ({ commit }, params) {
      const response = await axios.post('/membership/v1/goodsInfo', params)
      return response.data
    },
    // 支付订单信息
    async  orderList ({ commit }, params) {
      const response = await axios.post('/membership/v1/getUserLatestOrder', params)
      return response.data
    },
    // 天美贷主页等 特殊的svip资格校验
    async  indexSVIPVerify ({ commit }, params) {
      const response = await axios.post('/svip/v1/indexSVIPVerify', params)
      return response.data
    },
    //  获取配置x元
    async  getLockAmount ({ commit }, params) {
      const response = await axios.get('/index/v1/get-lockAmount', params)
      return response.data
    },
    //  视频会员获取秒杀url
    async  videoMemberUrl ({ commit }, params) {
      const response = await axios.get('/index/v1/video-member-url', params)
      return response.data
    },
    // 获取特权卡详情
    async queryDetailX ({ commit }, params) {
      const response = await axios.post('/privilege/v1/detail', params)
      return response.data
    },
    // 检查是否可以退款
    async queryCheckRefundX ({ commit }, params) {
      const response = await axios.post('/refund/member/v1/refundCheck', params)
      return response.data
    },
    // 下单接口
    async orderCreateX ({ commit }, params) {
      const response = await axios.post('/membership/v1/order-create', params)
      return response.data
    },
    // 获取vip的memberNo
    async queryVipMemberNo ({ commit }, params) {
      const response = await axios.post('/membership/v1/memberSpecialInfo', params)
      return response.data
    },
    // 发现页会员
    async memberFundPage ({ commit }, params) {
      const response = await axios.post('/membership/v1/memberFundPage', params)
      return response.data
    },
    // 顶部风险查询报告-发现页
    async discoverBanner ({ commit }, params) {
      const response = await axios.post('/index/v1/discover/credit-banner', params)
      return response.data
    },
    /* 查询是否在对应卡种的有效期中
      参数: memberTypes - [String]
      1. SVIP:svip卡片
      2. VIP:vip会员
      3. XMAPI：小美会员
      4. RACM：授信重审卡
      5. RWCM:提现重审卡
      6. FACM:授信提速卡
      7. KING:至尊王卡
      8. PASS: pass卡
    */
    async getMemberShipStatus ({ commit }, params) {
      const response = await axios.post('/membership/v1/haveMember', params)
      return response.data
    },
    async getBuyQualification ({ commit }, params) {
      const response = await axios.post('/membership/v1/haveBuyQualification', params)
      return response.data
    },
    async buyVipResult ({ commit }, params) {
      const response = await axios.post('/membership/v1/order-query', params)
      return response.data
    },
    async memberShipDetail ({ commit }, params) {
      const response = await axios.post('/membership/v1/memberShipDetail', params)
      return response.data
    },
    async queryBvipDetailX ({ commit }, params) {
      const response = await axios.post('/greatvip/v1/detail', params)
      return response.data
    }
  }
}
